<div class="alert alert-danger m-5" role="alert">
    <strong [appTranslate]="errorMessageTranslationKey">{{ serverErrorMessage }}</strong> 
</div>
